/** Canonical badge statuses */
export enum BadgeVariant {
  SUCCESS = 'success',
  ATTENTION = 'attention',
  ALERT = 'alert',
  NEUTRAL = 'neutral',
  INFO_PRIMARY = 'infoPrimary',
  INFO_SECONDARY = 'infoSecondary',
  INVERSE = 'inverse',
  NEUTRAL_TRANSPARENT = 'neutralTransparent',
  LYRA_AI = 'lyraAi',
}

/** Visual shapes */
export enum BadgeShape {
  ROUND = 'round',
  RECT = 'rect',
}

/** Geometry */
export const BADGE_HEIGHT = 24 // px
export const BADGE_ICON_SIZE = 18 // px

/** Spacing */
export const padding = {
  [BadgeShape.ROUND]: {
    text: { paddingVertical: 4, paddingHorizontal: 10 },
    icon: { paddingVertical: 4, paddingLeft: 8, paddingRight: 10 },
  },
  [BadgeShape.RECT]: {
    text: { paddingVertical: 4, paddingHorizontal: 8 },
    icon: { paddingVertical: 4, paddingLeft: 6, paddingRight: 8 },
  },
} as const

/** Border radii */
export const borderRadius = {
  [BadgeShape.ROUND]: 999,
  [BadgeShape.RECT]: 4,
} as const
